import thumbnail_soulcast from '../soulcast/thumbnail.png';

import image0 from '../soulcast/0.png';
import image1 from '../soulcast/1.png';
// import image2 from '../soulcast/2.png';
import image3 from '../soulcast/3.png';
import image4 from '../soulcast/4.png';
import image5 from '../soulcast/5.png';
import image6 from '../soulcast/6.png';
import image7 from '../soulcast/7.png';

export const SoulcastApp = {
  id: 10,
  type: 'web',
  thumbnails: [thumbnail_soulcast],
  screens: [image0, image1, image3, image4, image5, image6, image7],
  title: 'Soulcast – AI-Powered Voice Cloning & Text-to-Video Generation Platform',
  intro:
    "Welcome to Soulcast, the revolutionary AI-powered platform that turns your written words into lifelike voiceovers and engaging videos. Designed for creators, educators, marketers, and storytellers, Soulcast empowers users to generate dynamic media content using cutting-edge voice cloning and text-to-video generation. Explore how this intelligent platform is transforming digital content creation with speed, simplicity, and scalability.",
  features: [
    {
      title: "Advanced Voice Cloning",
      description:
        "Upload a sample and clone any voice with high accuracy and emotional tone. Perfect for branding, narration, or multilingual content using the same persona."
    },
    {
      title: "Text-to-Video Creation",
      description:
        "Turn any script into a fully rendered video using customizable avatars, backgrounds, and styles. Soulcast handles visuals, voice, and timing automatically."
    },
    {
      title: "Multilingual & Multi-Voice Support",
      description:
        "Create content in multiple languages and switch between different voice profiles with ease to engage global audiences."
    },
    {
      title: "Custom Avatars & Styles",
      description:
        "Choose from a variety of avatars or upload your own branded characters. Customize video styles, tones, and pacing to match your creative vision."
    },
    {
      title: "Real-Time Preview & Editing",
      description:
        "Make quick edits to your script, regenerate voice, or swap visuals — all in real time. No rendering delays or complex timelines."
    },
    {
      title: "Secure Cloud Storage & Exports",
      description:
        "Save your projects in the cloud with easy access to download, embed, or share your videos across platforms in multiple formats."
    },
    {
      title: "Analytics & Performance Tracking",
      description:
        "Monitor video performance, viewer retention, and engagement metrics to optimize your content strategy with actionable insights."
    }
  ],
  conclusion:
    "Soulcast is redefining the future of content creation by combining AI voice technology with automated video generation. Whether you're creating educational videos, marketing content, or personalized messages, Soulcast helps you scale your creativity — instantly and effortlessly. Start using Soulcast today and bring your ideas to life with AI-powered storytelling!"
};
